<div class="help h-100">
    <help *ngIf="modelService.systemService.showHelp"></help>
</div> 